import { z } from "zod";

const LIVANCE_TELEPHONE_NUMBER = "11933058210";

export const phoneSchema = z.object({
  phone: z
    .string({ required_error: "Você precisa informar um número de telefone." })
    .min(1, { message: "Você precisa informar um número de telefone." })
    .refine(
      (value) => /^\(\d{2}\) \d{4,5}-\d{4}$/.test(value),
      "Número de telefone inválido.",
    )
    .refine(
      (value) => value.replace(/\D/g, "") !== LIVANCE_TELEPHONE_NUMBER,
      "Número de telefone não permitido.",
    ),
});
